var s = '';
var offset = 10;

$(document).ready(function(){

	s = skrollr.init();

	$(window).bind('orientationchange',function(){ gettingResized(); });
	$(window).on('resize',function(){ gettingResized(); });
	gettingResized();

	// do color change for select
	selectColor();
	$('#subject').on('change',selectColor);


	// init masonry
	var msnry;
	setTimeout(function(){
		msnry = $('.social__grid').masonry({
			itemSelector: '.social__grid__item'
		})
	},500);

	// open imprint
	var cur_pos = 0;
	$(document).on('click','.open_imprint, .open_shop',function(e){

		e.preventDefault();
		$('.block--navigation').addClass('moved');

		var type = 'imprint';
		if($(this).hasClass('open_shop')) type = 'order';

		// current top state
		cur_pos = $(document).scrollTop();
		
		$('.block--' + type).animate({
			top:'0px'
		},350,'easeOutCubic',function(){

			$('.block--' + type).css({
				position:'absolute'
			});

			$('.content_wrap').css({
				position:'fixed',
				'margin-top':'-' + cur_pos + 'px'
			});

			$('html,body').scrollTop(0);
			$('body').addClass('autoheight');

		});

	});

	// close imprint
	$(document).on('click','.block--imprint .close, .block--order .close',function(){

		var type = 'imprint';
		if($(this).parents('.block--order').length) type = 'order';

		$('body').removeClass('autoheight');

		var imp_pos = $(document).scrollTop();
		$('.block--' + type).css({
			position:'fixed',
			'margin-top':'-' + imp_pos + 'px'
		});

		$('.content_wrap').attr('style','');
		$('html,body').scrollTop(cur_pos);
		
		$('.block--' + type).animate({
			top:'100%'
		},350,'easeInCubic',function(){
			$(this).attr('style','');

			$('.block--navigation').removeClass('moved');
		});

	});

	// load more social
	$(document).on('click','.social__loadMore a',function(){

		$.ajax({
			url:'ajax/social.php',
			type:'post',
			data:'offset='+offset,
			success:function(data){

				offset = offset + 10;

				var d = jQuery.parseJSON(data);

				if(!d.more){
					$('.social__loadMore').slideUp();
					$('.block--social .block__inner').css({
						'padding-bottom':'250px'
					});
				}

				var $data = $(d.data);

				msnry.masonry()
				.append( $data )
				.masonry( 'appended', $data )
				.masonry();

			}
		});

	});

	// select audio
	$(document).on('click','.audio__select__item',function(){

		if(!$(this).hasClass('audio__select__item--big')){

			var pl_id = $(this).attr('data-id');
			$('.audio__playlist iframe').attr('src','https://embed.spotify.com/?uri=https://play.spotify.com/user/schneckenmaxe/playlist/' + pl_id);

			var as_height = $('.audio__select').height();
			$('.audio__select').css({
				height: as_height + 'px'
			});

			$('.audio__select__item--big').removeClass('audio__select__item--big');
			$(this).addClass('audio__select__item--big');

			setTimeout(function(){
				$('.audio__select').attr('style','');
			},300);
		}

	});

	// scroll to
	$(document).on('click','.scrollTo',function(){

		var block = $(this).attr('data-to');
		var top_pos = $('#' + block).offset().top;

		$("html, body").animate({
			scrollTop: top_pos + 'px'
		},800,'easeInOutCubic');

	});


	$(document).on('scroll', function(){

		var top = $(document).scrollTop();

		// fixed navigation
		var window_height = $(window).height();

		if(top > window_height){
			$('.block--navigation').addClass('fixed');
		} else {
			$('.block--navigation').removeClass('fixed');
		}

		
		if(top > 0){
			$('.navigation').addClass('scrolled');
		} else {
			$('.navigation').removeClass('scrolled');
		}

		// fade to clean top img
		var $fadeAway = $('.parallax-mirror:last');
		var perc = ((top / (window_height / 100)) / .7) * .01;

		var opac = 0;

		if(perc < 70){
			opac = 1 - perc;
		}
		$fadeAway.css('opacity',opac);

	});
	$(document).scroll();


	// submit contact
	$(document).on('click','.contact__form .input.submit a',function(e){

		e.preventDefault();

		$('.contact__form input, .contact__form textarea, .contact__form select').removeClass('error');

		$.ajax({
			url:'ajax/sendmail.php',
			type:'post',
			data:$('.contact__form form').serialize(),
			success:function(response){

				if($.trim(response) == 'done'){

					$('.contact__form form').slideUp(350,'easeOutCubic');
					$('.contact__form .success').slideDown(350,'easeOutCubic');

				} else {
					var d = jQuery.parseJSON(response);
					for(var i=0;i<d.length;i++){
						$('#' + d[i]).addClass('error');
					}
				}

			}
		});

	});


	// submit order
	$(document).on('click','.order__form .input.submit a',function(e){

		e.preventDefault();

		$('.order__form input, .order__form select').removeClass('error');

		$.ajax({
			url:'ajax/cdorder.php',
			type:'post',
			data:$('.order__form').serialize(),
			success:function(response){

				if($.trim(response) == 'done'){

					$('.order__form').slideUp(350,'easeOutCubic');
					$('.order__right .success').slideDown(350,'easeOutCubic');

				} else {
					var d = jQuery.parseJSON(response);
					for(var i=0;i<d.length;i++){
						if(d[i] == 'pkg'){
							$('.order__form select').addClass('error');
						} else {
							$('#order-' + d[i]).addClass('error');
						}
					}
				}

			}
		});

	});

});

function gettingResized(){

	// skrollr
	setTimeout('s.refresh();',1000);

	// nav size
	var nav_height = $('.block--navigation').height();
	$('.block--navigation--wrap').css('height',nav_height);

	var window_height = $(window).height();
	var window_width = $(window).width();

	$('.block--top').css({
		height: window_height + 'px'
	});

	if(window_width < 768){
		skrollr.init().destroy();
	} else {
		skrollr.init();
	}
	
}



function selectColor(){
	var $subject = $('#subject');
	var subject_val = $subject.val();
	var color = 'white';

	if(Number(subject_val) == 0){
		color = '#585858';
	}

	$subject.css({
		color:color
	});
}
